module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-breadcrumb', {
    staticClass: "bread",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'homePageManager'
      }
    }
  }, [_vm._v("微页面管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("新增微页面")])], 1), _vm._v(" "), _c('div', [_c('el-form', {
    ref: "pageForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.pageForm,
      "rules": _vm.pagerules,
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "页面名称",
      "prop": "pageName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "placeholder": "页面名称"
    },
    model: {
      value: (_vm.pageForm.pageName),
      callback: function($$v) {
        _vm.$set(_vm.pageForm, "pageName", $$v)
      },
      expression: "pageForm.pageName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "机器编号",
      "prop": "kioskNo"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "机器编号"
    },
    on: {
      "change": function($event) {
        _vm.changeKioskNo()
      }
    },
    model: {
      value: (_vm.pageForm.kioskNo),
      callback: function($$v) {
        _vm.$set(_vm.pageForm, "kioskNo", $$v)
      },
      expression: "pageForm.kioskNo"
    }
  }, [_c('el-option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.getcookie('storeId') == 'store001'),
      expression: "this.getcookie('storeId')=='store001'"
    }],
    attrs: {
      "label": "K1-A112",
      "value": "K1-A112"
    }
  }, [_vm._v("K1-A112")]), _vm._v(" "), _c('el-option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.getcookie('storeId') == 'store001'),
      expression: "this.getcookie('storeId')=='store001'"
    }],
    attrs: {
      "label": "K1-A113",
      "value": "K1-A113"
    }
  }, [_vm._v("K1-A113")]), _vm._v(" "), _c('el-option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.getcookie('storeId') == '0001'),
      expression: "this.getcookie('storeId')=='0001'"
    }],
    attrs: {
      "label": "X2-A179",
      "value": "X2-A179"
    }
  }, [_vm._v("X2-A179")]), _vm._v(" "), _c('el-option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.getcookie('storeId') == '0001'),
      expression: "this.getcookie('storeId')=='0001'"
    }],
    attrs: {
      "label": "X2-A173",
      "value": "X2-A173"
    }
  }, [_vm._v("X2-A173")])], 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "pageForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.pageForm,
      "rules": _vm.pagerules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "组件类型",
      "prop": "componentType"
    }
  }, [_c('div', [(_vm.objinArrar({
    'type': 'banner',
    'name': '图片广告'
  }, _vm.componentTypes) < 0) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('banner')
      }
    }
  }, [_vm._v("图片广告")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('notice')
      }
    }
  }, [_vm._v("通知栏")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('specialOffer')
      }
    }
  }, [_vm._v("每日特价")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('goodsGroup')
      }
    }
  }, [_vm._v("商品分组")])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "52%",
      "text-align": "center"
    }
  }, [_c('div', [_vm._v("预览")]), _vm._v(" "), _vm._l((_vm.imgUrls), function(item, index) {
    return _c('div', [_c('img', {
      staticStyle: {
        "width": "360px",
        "margin-left": "60px"
      },
      attrs: {
        "src": item.imgUrl
      }
    }), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.editorComponent(index)
        }
      }
    }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.delComponent(index)
        }
      }
    }, [_vm._v("删除")])], 1)
  })], 2), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "id": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('pageForm')
      }
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.resetForm('pageForm')
      }
    }
  }, [_vm._v("重 置")])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "title": _vm.componentInfo.typeName,
      "modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    },
    model: {
      value: (_vm.componentInfo),
      callback: function($$v) {
        _vm.componentInfo = $$v
      },
      expression: "componentInfo"
    }
  }, [_c('div', [_c('el-form', {
    ref: "componentForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.componentForm,
      "rules": _vm.componentrules
    }
  }, [(_vm.componentInfo.type == 'banner') ? _c('el-form-item', {
    attrs: {
      "label": "素材资源"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "资源"
    },
    model: {
      value: (_vm.componentForm.sourceId),
      callback: function($$v) {
        _vm.$set(_vm.componentForm, "sourceId", $$v)
      },
      expression: "componentForm.sourceId"
    }
  }, _vm._l((_vm.resourcesList), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.componentInfo.type == 'notice') ? _c('el-form-item', {
    attrs: {
      "label": "显示文本"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "placeholder": "文本"
    },
    model: {
      value: (_vm.componentForm.content),
      callback: function($$v) {
        _vm.$set(_vm.componentForm, "content", $$v)
      },
      expression: "componentForm.content"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.componentInfo.type == 'notice') ? _c('el-form-item', {
    attrs: {
      "label": "背景颜色"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "placeholder": "背景颜色"
    },
    model: {
      value: (_vm.componentForm.bgColor),
      callback: function($$v) {
        _vm.$set(_vm.componentForm, "bgColor", $$v)
      },
      expression: "componentForm.bgColor"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.componentInfo.type == 'notice') ? _c('el-form-item', {
    attrs: {
      "label": "字体颜色"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "placeholder": "字体颜色"
    },
    model: {
      value: (_vm.componentForm.color),
      callback: function($$v) {
        _vm.$set(_vm.componentForm, "color", $$v)
      },
      expression: "componentForm.color"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.componentInfo.type == 'banner') ? _c('el-form-item', {
    attrs: {
      "label": "跳转目标"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "跳转目标类型"
    },
    model: {
      value: (_vm.componentForm.targetType),
      callback: function($$v) {
        _vm.$set(_vm.componentForm, "targetType", $$v)
      },
      expression: "componentForm.targetType"
    }
  }, _vm._l((_vm.targetTypeList), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.componentInfo.type == 'banner' && _vm.componentForm.targetType == 'web') ? _c('el-form-item', {
    attrs: {
      "label": "跳转链接"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "placeholder": "跳转链接"
    },
    model: {
      value: (_vm.componentForm.targetUrl),
      callback: function($$v) {
        _vm.$set(_vm.componentForm, "targetUrl", $$v)
      },
      expression: "componentForm.targetUrl"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.componentInfo.type == 'banner' && _vm.componentForm.targetType == 'goods') ? _c('el-form-item', {
    attrs: {
      "label": "商品信息"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "商品信息"
    },
    model: {
      value: (_vm.componentForm.targetUrl),
      callback: function($$v) {
        _vm.$set(_vm.componentForm, "targetUrl", $$v)
      },
      expression: "componentForm.targetUrl"
    }
  }, _vm._l((_vm.productList), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.productName,
        "value": item.productId
      }
    }, [_vm._v(_vm._s(item.productName))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.componentInfo.type == 'specialOffer' || (_vm.componentInfo.type == 'banner' && _vm.componentForm.targetType == 'activity')) ? _c('el-form-item', {
    attrs: {
      "label": "特价活动"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "特价活动"
    },
    model: {
      value: (_vm.componentForm.targetUrl),
      callback: function($$v) {
        _vm.$set(_vm.componentForm, "targetUrl", $$v)
      },
      expression: "componentForm.targetUrl"
    }
  }, _vm._l((_vm.specActList), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.act_name,
        "value": item.act_id
      }
    }, [_vm._v(_vm._s(item.act_name))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.componentInfo.type == 'goodsGroup') ? _c('el-form-item', {
    attrs: {
      "label": "显示数量"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "显示数量"
    },
    model: {
      value: (_vm.componentForm.layoutType),
      callback: function($$v) {
        _vm.$set(_vm.componentForm, "layoutType", $$v)
      },
      expression: "componentForm.layoutType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "每行2个",
      "value": "0"
    }
  }, [_vm._v("每行2个")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "每行3个",
      "value": "1"
    }
  }, [_vm._v("每行3个")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.componentInfo.type == 'goodsGroup' || (_vm.componentInfo.type == 'banner' && _vm.componentForm.targetType == 'goodsGroup')) ? _c('el-form-item', {
    attrs: {
      "label": "商品分组"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "商品分组"
    },
    model: {
      value: (_vm.componentForm.targetUrl),
      callback: function($$v) {
        _vm.$set(_vm.componentForm, "targetUrl", $$v)
      },
      expression: "componentForm.targetUrl"
    }
  }, _vm._l((_vm.goodsGroupList), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.groupName,
        "value": item.groupId
      }
    }, [_vm._v(_vm._s(item.groupName))])
  }), 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.saveComponentInfo()
      }
    }
  }, [_vm._v("确定")])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ef42239!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/homePage/addHomePage.vue
// module id = 1045
// module chunks = 2